import $ from 'jquery';
import Vue from 'vue';
import router from '@/router';
import store from '@/store';

window.jQuery = $;
var layer = require('layui-layer');

class Dialog {
    constructor () {}

    static close (index) {
        layer.close(index);
    }

    static closeAll() {
        layer.closeAll();
    }

    static show (title, component, options, params) {
        return new Promise((resolve, reject) => {
            let layerOptions = {
                title: title,
                type: 1,
                skin: 'layer-dialog',
                resize: false,
                offset: 'auto',
                zIndex: 1000,
                index: 0,
                contentDom: null
            };

            layerOptions = {...layerOptions, ...options};
            layerOptions.end = () => {
                if (layerOptions.contentDom)
                    document.body.removeChild(layerOptions.contentDom);
            }

            let observer = {
                cancel: function(isSuccess = false) {
                    layer.close(this.index);
                    if (isSuccess) {
                        resolve();
                    }
                    else {
                        reject();
                    }
                },
                index: -1,
            }
            layerOptions.cancel = () => {
                reject();
            }
            let dom = document.createElement('div');
            document.body.appendChild(dom);
            let Content = Vue.extend(component);
            let vueObj = new Content({router: router, store: store, propsData: params});
            vueObj.observer = observer;
            vueObj.inputParams = params;
            vueObj.$mount(dom);
            layerOptions.contentDom = vueObj.$el;
            layerOptions.content = $(layerOptions.contentDom);
            observer.index = layer.open(layerOptions);
        });
    }
}

Vue.prototype.$dialog = Dialog;

export default Dialog;


// WEBPACK FOOTER //
// ./src/components/dialog/index.js